export default "__VITE_ASSET__b6e6ed8c__"